import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mosta-select-wrapper" }
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = {
  key: 0,
  class: "mosta-select__value"
}
const _hoisted_4 = {
  key: 1,
  class: "mosta-select__placeholder"
}
const _hoisted_5 = {
  class: "mosta-select__options",
  ref: "optionsRef"
}
const _hoisted_6 = {
  key: 0,
  class: "mosta-select__no-option"
}
const _hoisted_7 = { class: "mosta-select__no-option-text" }
const _hoisted_8 = ["onClick", "onMouseenter"]
const _hoisted_9 = {
  key: 0,
  class: "mosta-select__divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "triggerRef",
      class: _normalizeClass(["mosta-select", {
        'mosta-select--open': _ctx.isOpen,
        'mosta-select--disabled': _ctx.disable,
        'mosta-select--focused': _ctx.isFocused,
      }]),
      tabindex: _ctx.disable ? -1 : 0,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTriggerKeydown && _ctx.onTriggerKeydown(...args))),
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
    }, [
      (_ctx.displayText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.displayText), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.label), 1)),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["mosta-select__chevron", { 'mosta-select__chevron--open': _ctx.isOpen }]),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("path", {
          d: "M4 6L8 10L12 6",
          stroke: "#999",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ]), 2))
    ], 42, _hoisted_2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "mosta-select-dropdown" }, {
        default: _withCtx(() => [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "floatingRef",
                class: "mosta-select__dropdown",
                style: _normalizeStyle(_ctx.floatingStyles),
                onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (!_ctx.options || !_ctx.options.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "no-option", {}, () => [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('no_data_found')), 1)
                        ], true)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (opt, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: _ctx.getOptionKey(opt, idx),
                      class: _normalizeClass(["mosta-select__item", {
                'mosta-select__item--active': _ctx.isSelected(opt),
                'mosta-select__item--highlighted': _ctx.highlightedIndex === idx,
                'mosta-select__item--divider': _ctx.isDivider(opt),
              }]),
                      ref_for: true,
                      ref: el => _ctx.setItemRef(el, idx),
                      onClick: _withModifiers(($event: any) => (_ctx.onOptionClick(opt)), ["stop"]),
                      onMouseenter: ($event: any) => (_ctx.onOptionMouseEnter(idx, opt))
                    }, [
                      (_ctx.isDivider(opt))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.getOptionLabel(opt)), 1)
                          ], 64))
                    ], 42, _hoisted_8))
                  }), 128))
                ], 512)
              ], 36))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ]))
}